const PICKUP_TIME_OPTIONS = {
  NOW: 'PICKUP_TIME_NOW',
}

export { PICKUP_TIME_OPTIONS }
